import { FC, useEffect, useRef, useState } from 'react';
import { fetchCurrentUser, type MeResponse } from '../../api/auth';
import OrderManagement from '../OrderManagement';

const AllOrdersPage: FC = () => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [role, setRole] = useState<string>('');

  useEffect(() => {
    let active = true;
    fetchCurrentUser()
      .then((me: MeResponse) => { if (active) setRole((me.role ?? me.user.typeKey ?? '') as string); })
      .catch(() => { if (active) setRole(''); });
    return () => { active = false; };
  }, []);

  useEffect(() => {
    const upper = (role || '').toUpperCase();
    const root = containerRef.current ?? document.body;

    const setNewOrderVisibility = (show: boolean) => {
      const buttons = root.querySelectorAll('button');
      buttons.forEach((btn) => {
        if ((btn.textContent || '').trim() === '+ New order') {
          (btn as HTMLButtonElement).style.display = show ? '' : 'none';
        }
      });
    };

    // ADMIN/ADVISOR: ensure button is visible and do not observe
    if (upper === 'ADMIN' || upper === 'ADVISOR' || upper === 'DIRECTOR') {
      setNewOrderVisibility(true);
      return;
    }

    // Others: hide and keep hiding on DOM changes
    setNewOrderVisibility(false);
    const observer = new MutationObserver(() => setNewOrderVisibility(false));
    observer.observe(root, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [role]);

  return (
    <div ref={containerRef}>
      <OrderManagement />
    </div>
  );
};

export default AllOrdersPage;
